export function Authentication({children}: any){
    // The protected Permissions request validates the signed token. A cookie
    // presence check cannot determine whether a token has expired or changed.
    return children;
}
